import React from "react";
import useDebugInformation from "../../../../hooks/useDebugInformation";
import StepNumberIcon from "../../StepNumberIcon";
import { useHighestValidTabForStep, useTabsWithValidStatesForStep } from "@utils/validation/hooks";
import { logger } from "@services/workers/helpers";

const name = "ButtonIcon";

type ButtonIconProps = {
    index: number
    step: number
    parent: string
}

// create react fc component returning icon component for each button by index
const ButtonIcon: React.FC<ButtonIconProps> = ({ index, step, parent }) => {
    // get highest valid state for step
    const highestValidStep = useHighestValidTabForStep(step);
    // get array of valid states for step
    const validSteps = useTabsWithValidStatesForStep(step);
    // set variant to green for valid state and red for invalid state
    const variant = validSteps[index - 1] ? "green" : "red";
    // create debug name
    const debugName = `${name}${parent}`;

    // log debug information
    logger.debug(`${debugName}->${ButtonIcon.name}`, `highestValidStep: ${highestValidStep} index: ${index} step: ${step} validSteps: ${validSteps}`);

    // use debug information
    useDebugInformation(debugName, { index, step, highestValidStep, variant });

    // return icon component
    switch (index) {
        case 1:
            return <StepNumberIcon number="1" variant={variant} />;
        case 2:
            return <StepNumberIcon number="2" variant={variant} />;
        case 3:
            return <StepNumberIcon number="3" variant={variant} />;
        default:
            return <StepNumberIcon number="4" variant={variant} />;
    }
}

ButtonIcon.displayName = name;


export default React.memo(ButtonIcon);